import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NudosSearchbarDropdown from '../NudosSearchbarDropdown/NudosSearchbarDropdown';
import { TcomponentSize } from '../../../types/global';
import { IKamClient } from '../../../types/kamClient.types';
import NudosHoverText from '../NudosHoverText/NudosHoverText';
import { getOrganizationData } from '../../../services/bussines';
import errorMessage from '../../../utils/errorMessage';
import './NudosKamClient.scss';

const NudosKamClient = ({
  customKamClientLabel,
  componentSize,
  currentValue,
  errorText,
  updateCurrentValueCallback,
  isDeactivated,
  handleBlur,
  organizationId,
  loadingKamClient
}: {
  organizationId: string | number;
  customKamClientLabel?: string;
  componentSize?: TcomponentSize;
  currentValue?: IKamClient | null;
  errorText?: string;
  updateCurrentValueCallback: (newValue?: IKamClient | null) => void;
  isDeactivated?: boolean;
  handleBlur?: (inputText: string) => void;
  loadingKamClient?: boolean;
}) => {
  const [initialData, setInitialData] = useState<IKamClient>();
  const [loadingKamClients, setLoadingKamClients] = useState<boolean>(false);
  const [availableClients, setAvailableClients] = useState<IKamClient[]>([]);
  const kamClientLabel = customKamClientLabel || '';
  const kamClientPlaceholderForDropdown = 'Selecciona el KAM';
  const [kamClientText, setKamClientText] = useState('');
  const { push } = useHistory();
  const fetchInfoOrganization = async () => {
    if (!organizationId) return;
    setLoadingKamClients(true);
    try {
      const response = await getOrganizationData(organizationId);
      const { availableKams, assignedKam } = response;
      if (currentValue === null && assignedKam) {
        setInitialData(assignedKam);
      }
      setAvailableClients(availableKams || []);
    } catch (error) {
      errorMessage();
    } finally {
      setLoadingKamClients(false);
    }
  };
  const getKamClientOptionUI = (
    isActive: boolean,
    rawBillingData: IKamClient,
    clickOptionCallback?: (option: IKamClient) => void
  ) => {
    const { id, email } = rawBillingData;
    const handleSelectOption = (option: IKamClient) => {
      if (!isActive) return;
      updateCurrentValueCallback(option);
      fetchInfoOrganization();
      clickOptionCallback && clickOptionCallback(option);
    };
    return (
      <div
        className="optionContainer cityOption"
        key={`kamOption${id}`}
        onClick={() => handleSelectOption(rawBillingData)}
      >
        <NudosHoverText
          onlyIfTruncated
          customClassName={!email ? 'empty' : undefined}
          text={email || 'Escoge la KAM'}
          charactersLimit={50}
        />
      </div>
    );
  };
  const onGoToConfig = () => {
    push('/configuration/details');
  };
  const NoResultUI = ({ searchString }: { searchString: string }) => {
    return (
      <div className="noResultUI">
        <p className="text">
          <span>"[{searchString}]"</span>
          no está en la lista. Revisa la ortografia o crea un nuevo usuario desde el módulo de Configuración
        </p>
        <div className="goToConfig" onClick={onGoToConfig}>
          Ir a Configuración
        </div>
      </div>
    );
  };
  const formDropdownOptionsCallback = (
    rawOptions: IKamClient[],
    clickOptionCallback?: (option: IKamClient) => void,
    searchString?: string
  ) => {
    const noResultsOption = (
      <div className="optionContainer" key="loading">
        {searchString ? <NoResultUI searchString={searchString} /> : 'Cargando ...'}
      </div>
    );
    if (rawOptions.length === 0) {
      return [noResultsOption];
    }
    const cityOptions = rawOptions.map(rawBillingData => {
      return getKamClientOptionUI(true, rawBillingData, clickOptionCallback);
    });
    return cityOptions;
  };
  const formSelectedOptionUICallback = (selectedOption: IKamClient) =>
    getKamClientOptionUI(false, selectedOption, undefined);

  const filterBySearchStringCallback = (search: string, rawOptions: IKamClient[]) => {
    return rawOptions.filter(rawBillingData => {
      return rawBillingData?.email?.toLowerCase().trim().includes(search.toLowerCase().trim());
    });
  };

  useEffect(() => {
    if (initialData?.email || !currentValue?.email) return;
    setInitialData(currentValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue?.email]);

  useEffect(() => {
    if (kamClientText && !initialData?.email) return setInitialData({ email: kamClientText });
    if (!initialData?.email) return;
    updateCurrentValueCallback({ email: kamClientText });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kamClientText]);

  useEffect(() => {
    fetchInfoOrganization();
    if (!initialData?.email) return;
    updateCurrentValueCallback(undefined);
    setKamClientText('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId]);
  return (
    <div className="nudosKamClient">
      <NudosSearchbarDropdown
        customClassname="nudosKamClientDropdownSearchbar"
        label={loadingKamClients ? '' : kamClientLabel}
        componentSize={componentSize}
        customPlaceholder={kamClientPlaceholderForDropdown}
        isFilled={!!currentValue}
        currentValue={currentValue || initialData}
        includeMagnifierIcon={false}
        rawOptions={availableClients}
        errorText={errorText}
        formDropdownOptionsCallback={formDropdownOptionsCallback}
        formSelectedOptionUICallback={formSelectedOptionUICallback}
        filterBySearchStringCallback={filterBySearchStringCallback}
        isDeactivated={isDeactivated}
        handleBlur={handleBlur}
        showSkeletonLoader={loadingKamClient || loadingKamClients}
      />
    </div>
  );
};

export default NudosKamClient;
